import { render, staticRenderFns } from "./JobInvoiceReview.vue?vue&type=template&id=4ff45d78&scoped=true&"
import script from "./JobInvoiceReview.vue?vue&type=script&lang=js&"
export * from "./JobInvoiceReview.vue?vue&type=script&lang=js&"
import style0 from "./JobInvoiceReview.vue?vue&type=style&index=0&id=4ff45d78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff45d78",
  null
  
)

export default component.exports